module.exports = __webpack_public_path__ + "static/media/ruby-slippers.80c48175.jpg";